/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown> }} Email_Meeting_SubjectInputs */

const th_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} อยากคุยด้วย`)
};

const en_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} would like to meet`)
};

const ja_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} さんが打ち合わせを希望しています`)
};

const zh_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 想与你会面`)
};

const es_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} quiere reunirse`)
};

const pt_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} quer conversar`)
};

const id_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} ingin bertemu dengan Anda`)
};

const fr_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} souhaite vous parler`)
};

const tl_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gustong makipagkita sa iyo ni ${i?.from}`)
};

const vi_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} muốn gặp bạn`)
};

const ko_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}님이 만나고 싶어 합니다`)
};

const de_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} möchte sich mit dir treffen`)
};

const ru_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} хочет встретиться с вами`)
};

const tr_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} sizinle görüşmek istiyor`)
};

const it_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} vuole incontrarti`)
};

const pl_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} chce się z tobą spotkać`)
};

const uk_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} хоче зустрітися з вами`)
};

const hi_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} आपसे मिलना चाहते हैं`)
};

const ar_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يريد ${i?.from} لقاءك`)
};

const ms_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} ingin berjumpa anda`)
};

const bn_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} আপনার সঙ্গে দেখা করতে চান`)
};

const zh_tw2_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 想與你會面`)
};

const zh_hk2_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 想與你會面`)
};

const ur_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} آپ سے ملنا چاہتے ہیں`)
};

const fa_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} می‌خواهد شما را ببیند`)
};

const sw_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} anataka kukutana nawe`)
};

const nl_email_meeting_subject = /** @type {(inputs: Email_Meeting_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} wil je spreken`)
};

/**
* | output |
* | --- |
* | "{from} would like to meet" |
*
* @param {Email_Meeting_SubjectInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_meeting_subject = /** @type {((inputs: Email_Meeting_SubjectInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Meeting_SubjectInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_meeting_subject(inputs)
	if (locale === "ja") return ja_email_meeting_subject(inputs)
	if (locale === "zh") return zh_email_meeting_subject(inputs)
	if (locale === "es") return es_email_meeting_subject(inputs)
	if (locale === "pt") return pt_email_meeting_subject(inputs)
	if (locale === "id") return id_email_meeting_subject(inputs)
	if (locale === "fr") return fr_email_meeting_subject(inputs)
	if (locale === "tl") return tl_email_meeting_subject(inputs)
	if (locale === "vi") return vi_email_meeting_subject(inputs)
	if (locale === "ko") return ko_email_meeting_subject(inputs)
	if (locale === "de") return de_email_meeting_subject(inputs)
	if (locale === "ru") return ru_email_meeting_subject(inputs)
	if (locale === "tr") return tr_email_meeting_subject(inputs)
	if (locale === "it") return it_email_meeting_subject(inputs)
	if (locale === "pl") return pl_email_meeting_subject(inputs)
	if (locale === "uk") return uk_email_meeting_subject(inputs)
	if (locale === "hi") return hi_email_meeting_subject(inputs)
	if (locale === "ar") return ar_email_meeting_subject(inputs)
	if (locale === "ms") return ms_email_meeting_subject(inputs)
	if (locale === "bn") return bn_email_meeting_subject(inputs)
	if (locale === "zh-TW") return zh_tw2_email_meeting_subject(inputs)
	if (locale === "zh-HK") return zh_hk2_email_meeting_subject(inputs)
	if (locale === "ur") return ur_email_meeting_subject(inputs)
	if (locale === "fa") return fa_email_meeting_subject(inputs)
	if (locale === "sw") return sw_email_meeting_subject(inputs)
	if (locale === "nl") return nl_email_meeting_subject(inputs)
	return en_email_meeting_subject(inputs)
});